import { memo, useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import ArrowRight from "@/components/ui/icon/arrow-right";

type Props = {
	onSetNextMonth: () => void;
	className?: string;
};

export const NextMonth = memo(({ onSetNextMonth, className }: Props) => {
	const handleClick = useCallback(() => {
		onSetNextMonth();
	}, [onSetNextMonth]);

	return (
		<button onClick={handleClick} className={cn("rounded bg-white p-2 text-center hover:bg-zinc-100", className)}>
			<ArrowRight className="h-[18px] w-[18px]" />
		</button>
	);
});

NextMonth.displayName = "NextMonth";
